// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ad0640ba","160":"0d984008","208":"631928ce","293":"85032427","516":"1576aa96","519":"3a69dc1e","917":"90bd6182","946":"da3d13f7"}[chunkId] + ".chunk.js";
};